import styled from 'styled-components'

export const ReScheduleItem = styled.div`
  width: 100%;
  padding-top: 26px;
  padding-bottom: 26px;
  display: flex;
  align-items: center;

  label {
    margin-left: 25px;
    color: ${({ theme }) => theme.colors.gray};
    strong {
      color: ${({ theme }) => theme.colors.lightGray};
    }
  }
`

export const ReScheduleDot = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 100%;

  background-color: #5d86da;
`
